/* eslint-disable no-unused-expressions */
/* eslint-disable class-methods-use-this */
class FlocktoryService {
  loadScript = () => {
    const flocktoryScript = document.createElement('script');
    const siteId = 1632;
    flocktoryScript.src = `//beeline.api.flocktory.com/v2/loader.js?site_id=${siteId}`;
    document.head.append(flocktoryScript);
  };

  /**
   * @param {{id: string, price: number, brand: string, categoryId: number}} item
   */
  addToCart = (item) => {
    const flocktoryInstance = (window && window.flocktory) || [];

    flocktoryInstance.push(['addToCart', { item }]);
  };
}

export const flocktoryService = new FlocktoryService();
